export enum ViewportDrawingMode {
  Freehand = 'Freehand',
  PointClick = 'PointClick',
  Threshold = 'Threshold',
  Nudge = 'Nudge',
  None = 'None',
}

export enum ViewportToolMode {
  WindowLevel = 'WindowLevel',
  Pan = 'Pan',
  Zoom = 'Zoom',
  ZoomSide = 'ZoomSide',
  Rotate = 'Rotate',
  Contour = 'Contour',
  None = 'None',
}
